<template>
    <a-modal
      :title="title"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showAvatarForm"
      :confirmLoading="loading"
      class="avatar-result"
      @cancel="close"
    >
        <a-form-model
          ref="form"
          :model="model"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-spin :spinning="loading">
            
            <a-form-model-item label="绑定优化师" prop="worker_id" v-if="model.bind_worker">
                <a-select placeholder="请选择" :default-value="model.worker_id" show-search   option-filter-prop="children"
                          v-model="model.worker_id">
                    <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                        {{ worker.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="品牌名称" prop="source_info" help='非必填'>
              <a-input v-model="model.source_info"/>
            </a-form-model-item>

            <a-form-model-item label="头像" prop="avatar">
                 <material-select v-model="model.avatar" :filters="{type:2,num:1,width:300,height:300,size:5}"/>
            </a-form-model-item>
          </a-spin>
        </a-form-model>
        <div class="result" v-if="result.success.length + result.errors.length > 0">
          <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
          <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
        </div>
        <template slot="footer" >
          <a-button @click="close" :disabled="loading">取消</a-button>
          <a-button type="primary" @click="submit" :disabled="loading" v-if="result.success.length + result.errors.length <= 0">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'CreateAvatar';
</style>

<script>
import CreateAvatar from './CreateAvatar'

export default CreateAvatar
</script>
